import React from 'react';

interface FormSectionProps {
  title: string;
  children?: React.ReactNode;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  children,
}) => {
  return (
    <div className="mt-4">
      <h2 className="font-bold text-md mb-2">{title}</h2>
      <div className="border border-black bg-[#f6f3e6]">{children}</div>
    </div>
  );
};
